<template>
  <div class="screen-3">
    <div class="inner">
      <div class="top">商品营销</div>
      <div
        class="middle"
      >商品营销模块包含了永辉各类好玩的营销活动，面对琳琅满目的商品，如何抓住小主们的心，打造爆款营销？不同时令节气，主推什么商品？在这里或许有不一样的灵感。</div>
      <div class="bottom">
        <div
          class="item"
          :style="`left: ${pointList[index][0]}px; top: ${pointList[index][1]}px; width: ${(pointList[index][0] + pointList[index][1] > 0) ? 220 : 450}px`"
          v-for="(item, index) in list"
          :key="index"
          @mouseover="hover(index)"
          @click="goto('/service/detail/' + item.id, true)"
        >
          <img
            :src="util.getImageUrl(item.image, '220x220')"
            v-if="pointList[index][0] + pointList[index][1] > 0"
          />
          <img :src="util.getImageUrl(item.image, '450x220')" v-else />
          <div class="intro" v-if="pointList[index][0] + pointList[index][1] < 1">
            <div class="title">{{item.name}}</div>
            <div class="content">{{item.description}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Screen from "./Screen";
export default {
  name: "Screen3",
  extends: Screen,
  data() {
    return {
      id: 3,
      activeIndex: 0,
      list: [],
      pointList: [[0, 0], [0, 230], [230, 230], [460, 230], [460, 0]]
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const response = await this.ajax.doPost({
        packageName: "index",
        className: "index",
        methodName: "index",
        params: {}
      });

      this.list = response.commodityMarketingList;

      setInterval(this.play, 2000);
    },
    play() {
      this.pointList = [
        this.pointList[1],
        this.pointList[2],
        this.pointList[3],
        this.pointList[4],
        this.pointList[0]
      ];
    },
    hover(index) {
      this.activeIndex = index;
    },
    goto(path, open) {
      if (open) {
        window.open(path);
      } else {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style lang="scss">
.screen-3 {
  .inner {
    width: 1200px;
    z-index: 3;
    .top {
      text-align: center;
      font-size: 56px;
      font-family: "FZQKBYSJW";
      font-weight: normal;
      color: rgba(255, 255, 255, 1);
    }

    .middle {
      margin-top: 50px;
      margin-bottom: 100px;
      text-align: center;
      font-size: 24px;
      font-weight: 200;
      color: rgba(255, 255, 255, 1);
      line-height: 42px;
    }

    .bottom {
      margin: 0 auto;
      width: 680px;
      height: 450px;
      // display: flex;
      // justify-content: space-between;
      // align-content: space-between;
      // flex-wrap: wrap;

      position: relative;

      .item {
        width: 220px;
        height: 220px;
        margin-bottom: 10px;
        cursor: pointer;
        transition: all 1s;
        position: absolute;
      }

      .item-active {
        width: 450px;
      }

      .intro {
        position: absolute;
        height: 110px;
        width: 450px;
        top: 110px;
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 1) 100%
        );
        .title {
          font-size: 20px;
          font-family: "FZQKBYSJW";
          font-weight: normal;
          color: rgba(255, 255, 255, 1);
          line-height: 22px;
          margin: 40px 15px 10px 15px;
        }
        .content {
          font-size: 12px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 16px;
          margin: 0px 15px 0 15px;
        }
      }
    }
  }
}
</style>